export default {"src":"/_next/static/media/hero-bug-right.gif.92627028.webp","height":400,"width":400,"blurWidth":0,"blurHeight":0};